import { render, staticRenderFns } from "./ModalOrdenar.vue?vue&type=template&id=6d40bbd2&"
import script from "./ModalOrdenar.vue?vue&type=script&lang=js&"
export * from "./ModalOrdenar.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrdenar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports